import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';
@Component({
    selector: 'installation-customer-attendees',
    templateUrl: './customer-attendees.component.html',
    standalone: false
})
export class InstallationCustomerAttendeesPluginComponent {
  public attendees: any[] = [];
  public config: any;
  public editRoute = ['installation', 'customerattendees', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.attendees = this.config.Attendees;
  }
}
PluginComponent.plugins['installationcustomerattendees'] = InstallationCustomerAttendeesPluginComponent;
